import api from './api';

const BASE = '/competition-workflow';

// --- Templates -----------------------------------------------------------
export const listCompetitionTemplates = async () => {
  const res = await api.get(`${BASE}/templates`);
  return res.data;
};

export const getCompetitionTemplate = async (templateId) => {
  const res = await api.get(`${BASE}/templates/${templateId}`);
  return res.data;
};

// --- Cohort (admin) ------------------------------------------------------
export const assignCohort = async (templateId, studentIds) => {
  const res = await api.post(`${BASE}/templates/${templateId}/assign`, { student_ids: studentIds });
  return res.data;
};

export const getCohort = async (templateId) => {
  const res = await api.get(`${BASE}/templates/${templateId}/cohort`);
  return res.data;
};

export const getEnrollmentWorkspace = async (enrollmentId) => {
  const res = await api.get(`${BASE}/enrollments/${enrollmentId}`);
  return res.data;
};

// --- Student -------------------------------------------------------------
export const getMyWorkspace = async (templateId) => {
  const res = await api.get(`${BASE}/templates/${templateId}/me`);
  return res.data;
};

export const getMyEnrollments = async () => {
  const res = await api.get(`${BASE}/me/enrollments`);
  return res.data;
};

// --- Submissions ---------------------------------------------------------
export const saveSubmission = async (submissionId, payload) => {
  const res = await api.post(`${BASE}/submissions/${submissionId}/save`, payload);
  return res.data;
};

export const uploadSubmissionFile = async (submissionId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`${BASE}/submissions/${submissionId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const getSubmissionFileUrl = async (submissionId) => {
  const res = await api.get(`${BASE}/submissions/${submissionId}/file`);
  return res.data.url;
};

export const reviewSubmission = async (submissionId, payload) => {
  const res = await api.post(`${BASE}/submissions/${submissionId}/review`, payload);
  return res.data;
};

export const reviewerEditSubmission = async (submissionId, payload) => {
  const res = await api.post(`${BASE}/submissions/${submissionId}/reviewer-edit`, payload);
  return res.data;
};

export const getDeadlineWatch = async (withinDays = 7) => {
  const res = await api.get(`${BASE}/deadline-watch`, { params: { within_days: withinDays } });
  return res.data;
};

export const adminUploadSubmission = async (submissionId, { file, linkUrl } = {}) => {
  const form = new FormData();
  if (file) form.append('file', file);
  if (linkUrl) form.append('link_url', linkUrl);
  const res = await api.post(`${BASE}/submissions/${submissionId}/admin-upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const allowResubmission = async (submissionId) => {
  const res = await api.post(`${BASE}/submissions/${submissionId}/allow-resubmission`);
  return res.data;
};

// --- Resubmission requests ------------------------------------------------
// The student's route back into an approved component: they ask with a reason,
// the mentor who owns them approves or denies it.
export const requestResubmission = async (submissionId, reason) => {
  const res = await api.post(`${BASE}/submissions/${submissionId}/resubmission-request`, { reason });
  return res.data;
};

export const getResubmissionRequests = async () => {
  const res = await api.get(`${BASE}/resubmission-requests`);
  return res.data;
};

export const decideResubmission = async (requestId, approve, note = null) => {
  const res = await api.post(`${BASE}/resubmission-requests/${requestId}/decide`, { approve, note });
  return res.data;
};

export const updateSubmissionDeadline = async (submissionId, internalDeadline) => {
  const res = await api.patch(`${BASE}/submissions/${submissionId}/deadline`, { internal_deadline: internalDeadline });
  return res.data;
};

// Download an approved deliverable (.docx). Triggers a browser download and
// resolves once the file is saved. docKey is a component's req_key — the API
// decides per competition which ones render as a document.
export const downloadCompetitionDocument = async (enrollmentId, docKey) => {
  const res = await api.get(`${BASE}/enrollments/${enrollmentId}/documents/${docKey}`, {
    responseType: 'blob',
  });
  const cd = res.headers['content-disposition'] || '';
  const match = /filename="?([^"]+)"?/.exec(cd);
  const filename = match ? match[1] : `${docKey}.docx`;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
